import React, { useState } from "react";
import { translate } from "translate/i18n";

type TicketType = {
  description: string;
};

type ChangeTicketTypeProps = {
  ticketType: string;
  newTicketType: string;
  blockTicket: boolean;
  skuteTicket: boolean;
  skuteChannelTicket: any;
  ticketData: {
    openId: string;
  };
  handleChange: React.ChangeEventHandler<HTMLSelectElement>;
  listType: TicketType[];
  handleSave: () => void;
};
export function ChangeTicketType(props: ChangeTicketTypeProps): JSX.Element {
  const {
    ticketType,
    newTicketType,
    blockTicket,
    skuteChannelTicket,
    skuteTicket,
    ticketData,
    handleChange,
    listType,
    handleSave,
  } = props;

  const [isThereNewValueToBeSaved, setIsThereNewValueToBeSaved] =
    useState(false);

  const internalChangeHandler: React.ChangeEventHandler<HTMLSelectElement> = (
    evt
  ) => {
    setIsThereNewValueToBeSaved(true);
    handleChange(evt);
  };

  const internalSaveHandler = () => {
    setIsThereNewValueToBeSaved(false);
    handleSave();
  };

  return (
    <>
      <label className="title-combo-details-client-chat">
        {translate("type")}
      </label>
      <div className="form-row">
        <div className="form-group col-lg-8">
          <select
            className="form-control"
            id="example-select"
            value={isThereNewValueToBeSaved ? newTicketType : ticketType}
            disabled={
              blockTicket ||
              skuteTicket ||
              skuteChannelTicket ||
              !!ticketData.openId
            }
            onChange={internalChangeHandler}
          >
            <option value="">{translate("select")}</option>
            {listType
              .sort((t1, t2) => (t1.description > t2.description ? 1 : -1))
              .map((data, index) => (
                <option key={index} value={data.description}>
                  {data.description}
                </option>
              ))}
          </select>
        </div>
        <button
          type="button"
          className="btn btn-outline-success"
          style={{ height: 38 }}
          onClick={internalSaveHandler}
          disabled={blockTicket || skuteTicket || !!ticketData.openId}
        >
          <i className=" uil-exchange"></i> {translate("confirm")}
        </button>
      </div>
    </>
  );
}
